import React from 'react'
import { VStack } from '@chakra-ui/react'
import HistoricalDetails from './details/HistoricalDetails'
import useHistoricalDetail from './details/useHistoricalDetail'
import useAccountStatus from './useAccountStatus'
import OCDetail from './details/OCDetail'

export default function AccountStatus() {
  const {
    historicalDetail,
    onCLickHistorical,
    onCloseHistorical,
    openHistoricalDetail,
  } = useHistoricalDetail()
  const {
    historicalDetail: ocDetail,
    onCLickHistorical: onClickOC,
    onCloseHistorical: onCloseOC,
    openHistoricalDetail: openOCDetail,
  } = useHistoricalDetail()

  const { historicalTable, purchaseOrdersTable, rechargesToBillTable } =
    useAccountStatus({ onCLickHistorical, onClickOC })

  return (
    <>
      <HistoricalDetails
        isOpen={openHistoricalDetail}
        onClose={onCloseHistorical}
        nDocument={historicalDetail}
      />
      <OCDetail isOpen={openOCDetail} nOC={ocDetail} onClose={onCloseOC} />
      <VStack w="100%" mb="100px" alignItems="flex-start" spacing={20}>
        {rechargesToBillTable}
        {historicalTable}
        {purchaseOrdersTable}
      </VStack>
    </>
  )
}
